import React from 'react';
import '../css/Popup.css'


const TeamPopUp = (props) => {


    if (props.content) {
        return (
            <div className="popup-box content-info">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="member-img borderimg"><img src={props.content.img} className="img-fluid"
                                                                       alt=""/></div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="member-info">

                                <h4>{props.content.name}</h4>

                                <span>{props.content.designation}</span>
                                <div className="social-networking popcss">
                                    <a href={props.content.linkedin} target="_blank"><i className="bi bi-linkedin"></i></a>
                                    {
                                        props.content.websiteLink &&
                                        <a href={props.content.websiteLink} target="_blank"><i
                                            className="bi bi-box-arrow-in-up-right"></i></a>

                                    }
                                </div>
                            </div>
                            <br/><br/>
                            <p>{props.content.content}</p>
                            <p>{props.content.experience && props.content.experience}</p>
                            <p>{props.content.experience1 && props.content.experience1}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default TeamPopUp



// WEBPACK FOOTER //
// ./src/components/TeamPopUp.js